var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4931_61732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H66C69.3137 0 72 2.68629 72 6V42C72 45.3137 69.3137 48 66 48H6C2.68629 48 0 45.3137 0 42V6Z",
    fill: "#D8E3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9658 15.0527H58.1939C57.0535 15.0527 56.1763 15.4036 55.65 16.544L48.457 32.9475H53.5447C53.5447 32.9475 54.4219 30.7545 54.5974 30.2282C55.1237 30.2282 60.1237 30.2282 60.8254 30.2282C61.0009 30.8422 61.4395 32.8598 61.4395 32.8598H66.0009L61.9658 15.0527ZM56.0009 26.544C56.4395 25.4913 57.9307 21.544 57.9307 21.544C57.9307 21.6317 58.3693 20.4913 58.5447 19.8773L58.8956 21.4562C58.8956 21.4562 59.8605 25.7545 60.036 26.6317H56.0009V26.544Z",
    fill: "#3362AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8048 27.0698C48.8048 30.754 45.4715 33.2101 40.296 33.2101C38.103 33.2101 35.9978 32.7715 34.8574 32.2452L35.5592 28.2101L36.1732 28.4733C37.7522 29.175 38.8048 29.4382 40.7346 29.4382C42.1381 29.4382 43.6294 28.9119 43.6294 27.6838C43.6294 26.8943 43.0153 26.368 41.0855 25.4908C39.2434 24.6136 36.7872 23.2101 36.7872 20.6663C36.7872 17.1575 40.2083 14.7891 45.0329 14.7891C46.875 14.7891 48.4539 15.1399 49.4188 15.5785L48.7171 19.4382L48.3662 19.0873C47.489 18.7364 46.3486 18.3856 44.682 18.3856C42.8399 18.4733 41.9627 19.2627 41.9627 19.9645C41.9627 20.754 43.0153 21.368 44.682 22.1575C47.489 23.4733 48.8048 24.9645 48.8048 27.0698Z",
    fill: "#3362AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15.2278L6.08772 14.877H13.6316C14.6842 14.877 15.4737 15.2278 15.7368 16.3682L17.4035 24.2629C15.7368 20.0524 11.8772 16.6313 6 15.2278Z",
    fill: "#F9B50B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0152 15.0526L20.3837 32.8596H15.2082L10.8223 17.9473C13.9802 19.9648 16.6117 23.1227 17.5767 25.3157L18.103 27.1578L22.8398 14.9648H28.0152V15.0526Z",
    fill: "#3362AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.035 14.9648H34.8596L31.7894 32.8596H26.9648L30.035 14.9648Z",
    fill: "#3362AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4931_61732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0d63786775804b938a3a854228dd7859.svg";
export { ForwardRef as ReactComponent };